import React from 'react';

import { Mobile } from 'components/Responsive';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { htmlT } from 'utils/generic';

import { Container, CenteredImage, Header, Subheader, NextButton, ButtonsContainer } from '../../styles';

interface Props {
  onSubmit: () => void;
}

const Welcome = ({ onSubmit }: Props) => {
  const { t } = useStoreTranslation();

  const handleSubmit = () => onSubmit();

  return (
    <Container>
      <Mobile>
        <CenteredImage marginBottom={48} width={120} src="/corporate/images/logo-netviajes.svg" />
      </Mobile>

      <Header black>{t('registrationOnboarding.welcome.title')}</Header>
      <Subheader>{htmlT(t, 'registrationOnboarding.welcome.subtitle')}</Subheader>

      <Mobile>
        <CenteredImage marginTop="auto" width={280} src="/corporate/images/registration-onboarding/plane-mobile.svg" />
      </Mobile>

      <ButtonsContainer left>
        <NextButton noMargin onClick={handleSubmit}>
          {t('registrationOnboarding.nextButton')}
        </NextButton>
      </ButtonsContainer>
    </Container>
  );
};

export default Welcome;
